import { CartContext } from './context/CartContext';
import { IoIosCart } from 'react-icons/io';
import React, { useContext, useRef } from 'react';
import '../styles/Cart.css';

export default function Cart() {
    const cartRef = useRef(null);
    const {
        cartState,
        showCartOverlay,
        setShowCartOverlay,
    } = useContext(CartContext);

    return (<div
        ref={cartRef}
        className={'cart-container'}>
        <button
            aria-label={'Cart'}
            onClick={() => setShowCartOverlay(() => {
                const newValue = !showCartOverlay;
                return newValue;
            })}>
            <IoIosCart
                className={'me-2'}
                size={'27px'}
            />
            <span
                className={'cart-counter'}>
                {cartState
                    ?.map((item) => item.quantity)
                    .reduce((prev, cur) => +prev + +cur, 0)
                    ?? 0}
            </span>
            <span
                className={'cart-label'}>
                View&nbsp;Cart
            </span>
        </button>
    </div>);
}